import React from 'react';
import { hasPermission, isAuthenticated } from './auth';
import { Route, Redirect } from 'react-router-dom';

export const PrivateRoute = (
    { component: Component, layout: Layout, titulo: Titulo, permissions: Permissions, ...rest }) => (
        <Route {...rest}
            render={props => (
                isAuthenticated() ?
                    hasPermission(Permissions) ?
                        (
                            <Layout titulo={Titulo}>
                                <Component {...props} />
                            </Layout>
                        )
                        :
                        (
                            <Redirect to={{ pathname: '/not-found', state: { from: props.location } }} />
                        )
                    :
                    (
                        <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
                    )
            )}
        />
    );
